/* eslint-disable no-unused-vars */
import { Button, Grid } from "@mui/material";
import { green, orange, purple, teal } from "@mui/material/colors";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import db from "../../../db/db";

const theme = createTheme({
  status: {
    danger: orange[500],
  },
});

const DigitButton = styled(Button)({
  width: "100%",
  height: "100%",
  fontSize: "1.2rem",
  color: theme.palette.getContrastText(teal[500]),
  backgroundColor: teal[700],
  "&:hover": {
    backgroundColor: teal[900],
  },
});

const ActionButton = styled(Button)({
  width: "100%",
  height: "100%",
  fontSize: "1.28rem",
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: green[500],
  "&:hover": {
    backgroundColor: green[700],
  },
});

const EnterButton = styled(Button)({
  width: "100%",
  height: "100%",
  fontSize: "1.2rem",
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: green[500],
  "&:hover": {
    backgroundColor: green[700],
  },
});

let prevKeyTime = 0;
export default function PaymentDigitPanel(props) {
  const { t } = useTranslation();
  const translate = t;
  const [digits, setDigits] = useState("");
  const [enableSaleSave, setEnableSaleSave] = useState(true);
  const [selectPrinter, setSelectPrinter] = useState([]);

  props.pRefs.digitPanel = {
    parentEvent: parentEvent,
  };

  function parentEvent(event, value1, value2, value3) {
    console.log("eventzz", event, value1);
    if (event === "onKeyPressed") {
      onKeyPressed(value1);
    }
    if (event === "getSetEnableSaleSaveFn") {
      return setEnableSaleSave;
    }
    if (event === "getEnableSaleSave") {
      return enableSaleSave;
    }
  }

  function onKeyPressed(value, buttonIndex) {
    console.log("valuewww", value);
    props.onKeyPressed(value, setEnableSaleSave, buttonIndex);
  }

  useEffect(() => {
    getConfigDb();
  }, []);

  async function getConfigDb() {
    let data = [];
    let dbData = await db.config
      .where("name")
      .equals("PAYMENT_SETTINGS")
      .toArray();

    let configJson = JSON.parse(dbData[0].configTxt);
    for (let d of configJson.printButtons) {
      let i = [
        {
          label: d.label,
          keyBoardShortCut: d.keyBoardShortCut,
        },
      ];
      data.push(i);
    }
    console.log("dataaa", data.length);
    setSelectPrinter(data.length == 2 ? data[1] : data[0]);
  }

  return (
    <ThemeProvider theme={theme}>
      <Grid container>
        <Grid item xs={12}>
          <table style={{ height: "100%", width: "100%" }}>
            <tbody>
              <tr>
                <td>
                  <DigitButton
                    disabled={!enableSaleSave}
                    onClick={() => {
                      onKeyPressed("1");
                    }}
                  >
                    1
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    disabled={!enableSaleSave}
                    onClick={() => {
                      onKeyPressed("2");
                    }}
                  >
                    2
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    disabled={!enableSaleSave}
                    onClick={() => {
                      onKeyPressed("3");
                    }}
                  >
                    3
                  </DigitButton>
                </td>
              </tr>
              <tr>
                <td>
                  <DigitButton
                    disabled={!enableSaleSave}
                    onClick={() => {
                      onKeyPressed("4");
                    }}
                  >
                    4
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    disabled={!enableSaleSave}
                    onClick={() => {
                      onKeyPressed("5");
                    }}
                  >
                    5
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    disabled={!enableSaleSave}
                    onClick={() => {
                      onKeyPressed("6");
                    }}
                  >
                    6
                  </DigitButton>
                </td>
              </tr>
              <tr>
                <td>
                  <DigitButton
                    disabled={!enableSaleSave}
                    onClick={() => {
                      onKeyPressed("7");
                    }}
                  >
                    7
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    disabled={!enableSaleSave}
                    onClick={() => {
                      onKeyPressed("8");
                    }}
                  >
                    8
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    disabled={!enableSaleSave}
                    onClick={() => {
                      onKeyPressed("9");
                    }}
                  >
                    9
                  </DigitButton>
                </td>
              </tr>
              <tr>
                <td>
                  <DigitButton
                    disabled={!enableSaleSave}
                    onClick={() => {
                      onKeyPressed(".");
                    }}
                  >
                    .
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    disabled={!enableSaleSave}
                    onClick={() => {
                      onKeyPressed("0");
                    }}
                  >
                    0
                  </DigitButton>
                </td>
                <td rowSpan={2}>
                  <EnterButton
                    disabled={!enableSaleSave}
                    onClick={() => {
                      onKeyPressed("Enter");
                    }}
                  >
                    {translate("Enter")}
                  </EnterButton>
                </td>
              </tr>
              <tr>
                {props.saleSetting.saveOptionInSales && (
                  <td>
                    <ActionButton
                      disabled={!enableSaleSave}
                      onClick={() => {
                        setEnableSaleSave(false);
                        onKeyPressed("Save");
                      }}
                      style={{ height: "64px" }}
                    >
                      <div
                        style={{
                          width: "100%",
                        }}
                      >
                        <Grid container>
                          <Grid item xs={12}>
                            {translate("Save")}
                          </Grid>
                          {props.saleSetting &&
                            props.saleSetting.showKeyboardShortcuts && (
                              <Grid
                                item
                                xs={12}
                                style={{ fontSize: "0.60rem" }}
                              >
                                {translate("Ctrl+S")}
                              </Grid>
                            )}
                        </Grid>
                      </div>
                    </ActionButton>
                  </td>
                )}
                {selectPrinter.map(
                  (item, index) =>
                    item && (
                      <td colSpan={props.saleSetting.saveOptionInSales ? 1 : 2}>
                        <ActionButton
                          disabled={!enableSaleSave}
                          onClick={() => {
                            setEnableSaleSave(false);
                            onKeyPressed("Print", 0);
                          }}
                          style={{ height: "64px" }}
                        >
                          <div
                            style={{
                              width: "100%",
                            }}
                          >
                            <Grid container>
                              <Grid item xs={12}>
                                {item.label}
                              </Grid>
                              {props.saleSetting &&
                                props.saleSetting.showKeyboardShortcuts && (
                                  <Grid
                                    item
                                    xs={12}
                                    style={{ fontSize: "0.60rem" }}
                                  >
                                    {item.keyBoardShortCut}
                                  </Grid>
                                )}
                            </Grid>
                          </div>
                        </ActionButton>
                      </td>
                    )
                )}
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

// {
//   selectPrinter.map(
//     (item, index) =>
//       item && (
//         <td colSpan={selectPrinter.length === 2 ? 1 : 2}>
//           <ActionButton
//             disabled={!enableSaleSave}
//             onClick={() => {
//               setEnableSaleSave(false);
//               onKeyPressed("Print", index);
//               console.log("index", index);
//             }}
//             style={{ height: "64px" }}
//           >
//             <div
//               style={{
//                 width: "100%",
//               }}
//             >
//               <Grid container>
//                 <Grid item xs={12}>
//                   {item[0].label}
//                 </Grid>
//                 {props.saleSetting &&
//                   props.saleSetting.showKeyboardShortcuts && (
//                     <Grid item xs={12} style={{ fontSize: "0.60rem" }}>
//                       {item[0].keyBoardShortCut}
//                     </Grid>
//                   )}
//               </Grid>
//             </div>
//           </ActionButton>
//         </td>
//       )
//   );
// }

//  <tr>
//    {props.saleSetting.saveOptionInSales && (
//      <td>
//        <ActionButton
//          disabled={!enableSaleSave}
//          onClick={() => {
//            setEnableSaleSave(false);
//            onKeyPressed("Save");
//          }}
//          style={{ height: "64px" }}
//        >
//          <div
//            style={{
//              width: "100%",
//            }}
//          >
//            <Grid container>
//              <Grid item xs={12}>
//                {translate("Save")}
//              </Grid>
//              {props.saleSetting && props.saleSetting.showKeyboardShortcuts && (
//                <Grid item xs={12} style={{ fontSize: "0.60rem" }}>
//                  {translate("Ctrl+S")}
//                </Grid>
//              )}
//            </Grid>
//          </div>
//        </ActionButton>
//      </td>
//    )}
//    <td colSpan={props.saleSetting.saveOptionInSales ? 1 : 2}>
//      <ActionButton
//        disabled={!enableSaleSave}
//        onClick={() => {
//          setEnableSaleSave(false);
//          onKeyPressed("Print");
//        }}
//        style={{ height: "64px" }}
//      >
//        <div
//          style={{
//            width: "100%",
//          }}
//        >
//          <Grid container>
//            <Grid item xs={12}>
//              {translate("Print")}
//            </Grid>
//            {props.saleSetting && props.saleSetting.showKeyboardShortcuts && (
//              <Grid item xs={12} style={{ fontSize: "0.60rem" }}>
//                {translate("F12")}
//              </Grid>
//            )}
//          </Grid>
//        </div>
//      </ActionButton>
//    </td>
//  </tr>
